export const BASE_COVERAGE_DATA_PATH = "coverage-data";

export const COVERAGE_DATA_ROUTES = {
  POLICY_NOT_FOUND: "policy-not-found",
  POLICY_ALREADY_ADDED: "policy-already-added",
  COVERAGE_DETAILS: "coverage-details",
  EXTERNAL_COVERAGE: "external-coverage",
};
